export default __webpack_public_path__ + "static/media/chatApp_2.6c47143f.png";